import { SVGProps } from 'react';
const SvgFolderOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 20H4a1 1 0 0 1-1-1V6h17a1 1 0 0 1 1 1v6"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.326 20h15.92a1 1 0 0 0 .961-.725l1.429-5A1 1 0 0 0 21.674 13H5l-1.636 5.725A1 1 0 0 0 4.326 20ZM12 6l-1.707-1.707A1 1 0 0 0 9.586 4H4a1 1 0 0 0-1 1v1"
    />
  </svg>
);
export default SvgFolderOpen;
